<div class="rounded-lg bg-white p-6 shadow-sm">
  <h1 class="text-primary mb-4 text-2xl font-bold" i18n="@@wishlistTitle">Wishlist</h1>
</div>
